module.exports = __webpack_public_path__ + "img/indorex+db.299bb22b.png";